import type { CSSProperties, ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { modulesForCourse } from '../data/catalog'
import { useProgress } from '../state/ProgressContext'
import type { CourseDefinition } from '../types'
import { Icon } from './Icon'

function CourseArt({ number }: { number: number }) {
  const drawings: Record<number, ReactNode> = {
    1: <><path d="M10 48h44" /><path d="M16 42V32m11 10V25m11 17V17m11 25V9" /><path className="accent" d="M14 25c8-8 15-9 22-5 6 3 9 1 15-6" /></>,
    2: <><path d="M9 31 32 12l23 19v22H9V31Z" /><path d="M25 53V37h14v16" /><circle className="accent-fill" cx="47" cy="18" r="7" /></>,
    3: <><rect x="12" y="8" width="40" height="48" rx="7" /><path d="M20 20h24M20 29h24M20 38h11M20 47h11" /><path className="accent" d="M41 36v18m-5-14c0-5 10-5 10 0s-10 5-10 10 10 5 10 0" /></>,
    4: <><circle cx="32" cy="32" r="22" /><path d="M32 32V10a22 22 0 0 1 19 33L32 32Z" /><path className="accent" d="m32 32-16 15" /></>,
    5: <><path d="m8 30 24-19 24 19" /><path d="M14 27v27h36V27" /><path d="M26 54V39h12v15" /><path className="accent" d="M45 17v-7h7v12" /></>,
    6: <><path d="M9 46h46" /><path d="M15 46c3-13 10-21 17-21s14 8 17 21" /><circle className="accent-fill" cx="32" cy="15" r="8" /><path d="M19 55h26" /></>,
    7: <><path d="M32 55V22" /><path d="M32 32c-10 0-17-6-18-16 10-1 17 5 18 16Zm0 9c10 0 17-6 18-16-10-1-17 5-18 16Z" /><circle className="accent-fill" cx="32" cy="13" r="7" /></>,
    8: <><rect x="12" y="8" width="40" height="48" rx="7" /><path d="M20 21h22M20 32h13M20 43h15" /><path className="accent" d="m38 40 5 5 11-14" /></>,
  }
  return <svg viewBox="0 0 64 64" aria-hidden="true">{drawings[number]}</svg>
}

export function CourseCard({ course }: { course: CourseDefinition }) {
  const modules = modulesForCourse(course.id)
  const { progress } = useProgress()
  const allSections = modules.flatMap((module) => module.sections.map((section) => `${module.id}:${section.sectionId}`))
  const complete = allSections.filter((key) => Boolean(progress.completedSections[key])).length
  const percent = allSections.length ? Math.round((complete / allSections.length) * 100) : 0
  return (
    <Link className="course-card" to={`/courses/${course.id}`} style={{ '--course-color': course.color, '--course-soft': course.softColor } as CSSProperties}>
      <span className="course-art"><CourseArt number={course.number} /></span>
      <span className="course-card-copy">
        <span className="course-labels"><span>Course {course.number}</span><span>{course.eyebrow}</span></span>
        <strong>{course.title}</strong>
        <p>{course.description}</p>
        <span className="course-meta">{modules.length} modules · {course.preview}</span>
        <span className="course-progress"><span><i style={{ width: `${percent}%` }} /></span><b>{percent}%</b></span>
      </span>
      <span className="course-go"><Icon name="chevron" /></span>
    </Link>
  )
}
